import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './styles.css';

const MobileNav = ({ isDarkMode, toggleTheme }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const menuItems = {
        "About Me": [
            { id: 'about', icon: '/images/siteElements/menubar/me.png', label: 'Me' },
            { id: 'education', icon: '/images/siteElements/menubar/edu.png', label: 'Education' },
            { id: 'hobbies', icon: '/images/siteElements/menubar/hobbies.png', label: 'Hobbies' }
        ],
        "Professional": [
            { id: 'experience', icon: '/images/siteElements/menubar/exp.png', label: 'Experience' },
            { id: 'research', icon: '/images/siteElements/menubar/research.png', label: 'Research' },
            { id: 'skills', icon: '/images/siteElements/menubar/skills.png', label: 'Skills' },
            { id: 'activities', icon: '/images/siteElements/menubar/activities.png', label: 'Activities' }
        ],
        "Miscellaneous": [
            { id: 'accolades', icon: '/images/siteElements/menubar/ach.png', label: 'Accolades' },
            { id: 'projects', icon: '/images/siteElements/menubar/proj.png', label: 'Projects' },
            { id: 'blogs', icon: '/images/siteElements/menubar/blog.png', label: 'Blog' }
        ]
    };

    const getCurrentPath = () => {
        return location.pathname.replace('/', '') || 'about';
    };

    const handleNavClick = (id) => {
        navigate(`/${id}`);
        setIsMenuOpen(false);
    };

    const handleHomeClick = () => {
        navigate('/about');
        setIsMenuOpen(false);
    };

    return (
        <>
            {/* Top Navigation Bar */}
            <div className="mobile-nav-header">
                <img
                    src={isDarkMode ? "/images/siteElements/menubar/menu_namie_dark.png" : "/images/siteElements/menubar/menu_namie_light.png"}
                    alt="Logo"
                    className="mobile-nav-logo"
                    onClick={handleHomeClick}
                />
                <div className="mobile-nav-controls">
                    <div
                        className={`mobile-menu-toggle ${isMenuOpen ? 'open' : ''}`}
                        onClick={() => setIsMenuOpen(!isMenuOpen)}
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            </div>

            {/* Sliding Menu Overlay */}
            <div className={`mobile-menu-overlay ${isMenuOpen ? 'open' : ''}`} onClick={() => setIsMenuOpen(false)} />

            {/* Sliding Menu */}
            <div className={`mobile-menu ${isMenuOpen ? 'open' : ''}`}>
                <div className="mobile-menu-content">
                    {Object.entries(menuItems).map(([category, items]) => (
                        <div key={category} className="mobile-menu-category">
                            <div className="mobile-category-title">{category}</div>
                            <div className="mobile-category-items">
                                {items.map(item => (
                                    <div
                                        key={item.id}
                                        className={`mobile-menu-item ${getCurrentPath() === item.id ? 'active' : ''}`}
                                        onClick={() => handleNavClick(item.id)}
                                    >
                                        {getCurrentPath() === item.id && <div className="mobile-active-indicator" />}
                                        <img src={item.icon} alt={item.label} className="mobile-menu-icon" />
                                        <span className="mobile-menu-label">{item.label}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}

                    {/* Theme Toggle & Resume in Menu */}
                    <div className="mobile-menu-footer">
                        <div className="mobile-theme-toggle-container" onClick={toggleTheme}>
                            <img
                                src={isDarkMode ? '/images/siteElements/contentHeader/sun.png' : '/images/siteElements/contentHeader/moon.png'}
                                alt="Toggle Theme"
                                className="mobile-menu-theme-icon"
                            />
                            <span className="mobile-menu-label">
                                {isDarkMode ? 'Light Mode' : 'Dark Mode'}
                            </span>
                        </div>
                        <a
                            href="/AviResume.pdf"
                            download="AviResume.pdf"
                            className="mobile-resume-btn"
                            onClick={() => setIsMenuOpen(false)}
                        >
                            <i className="fa-solid fa-download"></i>
                            Download Résumé
                        </a>
                    </div>
                </div>
            </div>
        </>
    );
};

export default MobileNav;
